import { getSCorpBundleBuyButtonConfig } from '../utils/sCorpBundleEntitlements';

/**
 * Returns S Corp Bundle landing config; uses the S Corp Bundle No ZB Banking config when the ZB Banking Sunset Phase 1 flag is enabled.
 * @param {boolean} isZbBankingSunsetPhase1
 * @param {Set<string>} entitlements
 * @returns {object}
 */
// eslint-disable-next-line no-unused-vars
export function getSCorpBundleConfig(isZbBankingSunsetPhase1, entitlements = new Set()) {
  return {
    hero: {
      defaultPackageIndex: 1,
      buyBox: [
        {
          bulletPoints: [
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint1' },
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint2' },
          ],
          productDescription: 'productPage.sCorpBundle.buyBox.productDescription1',
          packageName: 'productPage.sCorpBundle.optionLabel.option1',
          productName: 'productPage.sCorpBundle.buyBox.productName1',
          priceLabel: 'productPage.sCorpBundle.buyBox.priceLabel',
          priceNote: 'productPage.sCorpBundle.buyBox.priceNote',
          veloCta: {
            displayVeloCta: true,
            promptMessageId: 'productPage.sCorpBundle.buyBox.veloCta.prompt',
            topic: 'form-llc-s-corp',
          },
          interactService: {
            service: 's_corp_basic_bundle_v1',
            ctaType: 'internalCheckout',
            isPurchasedByOrderTask: true,
            interval: 'annual',
          },
        },
        {
          bulletPoints: [
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint1' },
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint2' },
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint3' },
            ...(isZbBankingSunsetPhase1 ? [] : [{ title: 'productPage.sCorpBundle.buyBox.bulletPoint6' }]),
          ],
          packageColor: 'palette.background.green.main',
          productDescription: isZbBankingSunsetPhase1
            ? 'productPage.sCorpBundle.buyBox.productDescription2NoBanking'
            : 'productPage.sCorpBundle.buyBox.productDescription2',
          packageName: 'productPage.sCorpBundle.optionLabel.option2',
          productName: 'productPage.sCorpBundle.buyBox.productName2',
          packageNote: 'productPage.sCorpBundle.optionLabel.option2Callout',
          veloCta: {
            displayVeloCta: true,
            promptMessageId: 'productPage.sCorpBundle.buyBox.veloCta.prompt',
            topic: 'form-llc-s-corp',
          },
          interactService: {
            service: 's_corp_essential_bundle_v1',
            ctaType: 'internalCheckout',
            isPurchasedByOrderTask: true,
            interval: 'annual',
          },
        },
        {
          bulletPoints: [
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint1' },
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint2' },
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint3' },
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint4' },
            { title: 'productPage.sCorpBundle.buyBox.bulletPoint5' },
            ...(isZbBankingSunsetPhase1 ? [] : [{ title: 'productPage.sCorpBundle.buyBox.bulletPoint6' }]),
          ],
          packageColor: 'palette.background.cyan.main',
          productDescription: 'productPage.sCorpBundle.buyBox.productDescription3',
          packageName: 'productPage.sCorpBundle.optionLabel.option3',
          productName: 'productPage.sCorpBundle.buyBox.productName3',
          packageNote: 'productPage.sCorpBundle.optionLabel.option3Callout',
          veloCta: {
            displayVeloCta: true,
            promptMessageId: 'productPage.sCorpBundle.buyBox.veloCta.prompt',
            topic: 'form-llc-s-corp',
          },
          interactService: {
            service: 's_corp_premium_bundle_v1',
            ctaType: 'internalCheckout',
            isPurchasedByOrderTask: true,
            interval: 'annual',
          },
        },
      ],
      comparePackages: 'productPage.sCorpBundle.buyBox.comparePackages',
      plans: {
        title: 'productPage.sCorpBundle.compareModal.title',
        items: [
          {
            name: 'productPage.sCorpBundle.optionLabel.option1',
            features: [
              'productPage.sCorpBundle.comparePackages.features.option8',
              'productPage.sCorpBundle.comparePackages.features.option1',
              'productPage.sCorpBundle.comparePackages.features.option2',
              ...(isZbBankingSunsetPhase1 ? [] : ['productPage.sCorpBundle.comparePackages.features.option11']),
              'productPage.sCorpBundle.comparePackages.features.option7',
            ],
            tag: null,
            icon: {
              src: '/s2/material-icons/ShieldRounded.svg',
              color: 'text.tertiary',
              bgColor: 'grey',
            },
          },
          {
            name: 'productPage.sCorpBundle.optionLabel.option2',
            features: [
              'productPage.sCorpBundle.comparePackages.features.option9',
              'productPage.sCorpBundle.comparePackages.features.option1',
              'productPage.sCorpBundle.comparePackages.features.option2',
              'productPage.sCorpBundle.comparePackages.features.option3',
              ...(isZbBankingSunsetPhase1 ? [] : ['productPage.sCorpBundle.comparePackages.features.option6']),
              'productPage.sCorpBundle.comparePackages.features.option7',
            ],
            tag: {
              label: 'productPage.sCorpBundle.optionLabel.option2Callout',
              color: 'palette.secondary.light',
            },
            icon: {
              src: '/s2/material-icons/GppGoodRounded.svg',
              color: 'text.green',
              bgColor: 'green',
            },
          },
          {
            name: 'productPage.sCorpBundle.optionLabel.option3',
            features: [
              'productPage.sCorpBundle.comparePackages.features.option10',
              'productPage.sCorpBundle.comparePackages.features.option1',
              'productPage.sCorpBundle.comparePackages.features.option2',
              'productPage.sCorpBundle.comparePackages.features.option3',
              'productPage.sCorpBundle.comparePackages.features.option4',
              'productPage.sCorpBundle.comparePackages.features.option5',
              ...(isZbBankingSunsetPhase1 ? [] : ['productPage.sCorpBundle.comparePackages.features.option6']),
              'productPage.sCorpBundle.comparePackages.features.option7',
            ],
            tag: {
              label: 'productPage.sCorpBundle.optionLabel.option3Callout',
              color: 'palette.background.cyan.main',
            },
            icon: {
              src: '/s2/material-icons/WorkspacePremiumRounded.svg',
              color: 'text.blue',
              bgColor: 'cyan',
            },
          },
        ],
      },
      headerPicture: {
        src: '/s2/raster/standalone-header-s-corp.png',
        alt: 'productPage.sCorpBundle.heroPicture.altText',
      },
      headline: 'productPage.sCorpBundle.page.headline',
      partnerLogo: {},
      partnerReviewBlanks: [],
      subheader: 'productPage.sCorpBundle.page.subheader',
      intro: 'productPage.sCorpBundle.page.intro',
    },
    benefit: {
      title: 'productPage.sCorpBundle.valueProp.title',
      items: [
        {
          icon: '/s2/material-icons/ReceiptLongRounded.svg',
          title: 'productPage.sCorpBundle.valueProp.propTitle1',
          description: 'productPage.sCorpBundle.valueProp.shortCopy1',
        },
        {
          icon: '/s2/material-icons/InventoryRounded.svg',
          title: 'productPage.sCorpBundle.valueProp.propTitle2',
          description: isZbBankingSunsetPhase1
            ? 'productPage.sCorpBundle.valueProp.shortCopy2NoBanking'
            : 'productPage.sCorpBundle.valueProp.shortCopy2',
        },
        {
          icon: '/s2/material-icons/AttachMoneyRounded.svg',
          title: 'productPage.sCorpBundle.valueProp.propTitle3',
          description: 'productPage.sCorpBundle.valueProp.shortCopy3',
        },
      ],
    },
    highlight: {
      icon: '/s2/material-icons/FileDownloadDoneRounded.svg',
      title: 'productPage.sCorpBundle.topFeature.title',
      subheader: 'productPage.sCorpBundle.topFeature.subheader',
      bulletPoints: [
        { title: 'productPage.sCorpBundle.topFeature.bulletPoint1' },
        { title: 'productPage.sCorpBundle.topFeature.bulletPoint2' },
        { title: 'productPage.sCorpBundle.topFeature.bulletPoint3' },
        { title: 'productPage.sCorpBundle.topFeature.bulletPoint4' },
      ],
      image: '/s2/raster/standalone-feature-banner-s-corp.png',
      alt: 'productPage.sCorpBundle.topFeature.altText',
    },
    howItWorks: {
      title: 'productPage.sCorpBundle.howItWorks.title',
      items: [
        {
          title: 'productPage.sCorpBundle.howItWorks.step1',
          description: 'productPage.sCorpBundle.howItWorks.shortDescription1',
        },
        {
          title: 'productPage.sCorpBundle.howItWorks.step2',
          description: 'productPage.sCorpBundle.howItWorks.shortDescription2',
        },
        {
          title: 'productPage.sCorpBundle.howItWorks.step3',
          description: isZbBankingSunsetPhase1
            ? 'productPage.sCorpBundle.howItWorks.shortDescription3NoBanking'
            : 'productPage.sCorpBundle.howItWorks.shortDescription3',
        },
      ],
      image: '/s2/raster/standalone-how-it-works-s-corp.png',
      alt: 'productPage.sCorpBundle.howItWorks.altText',
      hasNumber: true,
      hasDivider: false,
      hasMobileImage: true,
    },
    whatsIncluded: {
      title: 'productPage.sCorpBundle.whatsIncluded.title',
      items: [
        {
          title: 'productPage.sCorpBundle.whatsIncluded.item1',
          description: 'productPage.sCorpBundle.whatsIncluded.item1ShortDescription',
        },
        {
          title: 'productPage.sCorpBundle.whatsIncluded.item2',
          description: 'productPage.sCorpBundle.whatsIncluded.item2ShortDescription',
        },
        {
          title: 'productPage.sCorpBundle.whatsIncluded.item3',
          description: 'productPage.sCorpBundle.whatsIncluded.item3ShortDescription',
        },
        {
          title: 'productPage.sCorpBundle.whatsIncluded.item4',
          description: 'productPage.sCorpBundle.whatsIncluded.item4ShortDescription',
        },
        {
          title: 'productPage.sCorpBundle.whatsIncluded.item5',
          description: 'productPage.sCorpBundle.whatsIncluded.item5ShortDescription',
        },
        ...(isZbBankingSunsetPhase1
          ? []
          : [
              {
                title: 'productPage.sCorpBundle.whatsIncluded.item6',
                description: 'productPage.sCorpBundle.whatsIncluded.item6ShortDescription',
              },
            ]),
        {
          title: 'productPage.sCorpBundle.whatsIncluded.item7',
          description: 'productPage.sCorpBundle.whatsIncluded.item7ShortDescription',
          link: {
            text: 'productPage.sCorpBundle.whatsIncluded.item7Link',
            href: 'https://gusto.com/go/bd/zenbusiness?idgm=m1w2pyol',
          },
        },
      ],
      image: '/s2/raster/standalone-whats-included-s-corp.png',
      alt: 'productPage.sCorpBundle.whatsIncluded.altText',
      hasDivider: true,
      hasNumber: false,
      hasMobileImage: false,
    },
    faqs: {
      title: 'productPage.sCorpBundle.frequentlyAskedQuestions.title',
      items: [
        {
          question: 'productPage.sCorpBundle.frequentlyAskedQuestions.faq1',
          answer: 'productPage.sCorpBundle.frequentlyAskedQuestions.faqAnswer1',
        },
        {
          question: 'productPage.sCorpBundle.frequentlyAskedQuestions.faq2',
          answer: 'productPage.sCorpBundle.frequentlyAskedQuestions.faqAnswer2',
        },
        {
          question: 'productPage.sCorpBundle.frequentlyAskedQuestions.faq3',
          answer: 'productPage.sCorpBundle.frequentlyAskedQuestions.faqAnswer3',
        },
        {
          question: 'productPage.sCorpBundle.frequentlyAskedQuestions.faq4',
          answer: 'productPage.sCorpBundle.frequentlyAskedQuestions.faqAnswer4',
        },
      ],
    },
    assistance: {
      title: 'productPage.sCorpBundle.needAssistance.title',
      getInTouch: 'productPage.sCorpBundle.needAssistance.getInTouch',
      actions: 'productPage.sCorpBundle.needAssistance.actions',
      additionalAssistance: [
        {
          icon: '/s2/material-icons/InsertInvitationRounded.svg',
          title: 'productPage.sCorpBundle.needAssistance.expertTitle',
          actions: 'productPage.sCorpBundle.needAssistance.expertActions',
          href: 'tel:8885142944',
        },
      ],
    },
    getBuyButtonConfig: getSCorpBundleBuyButtonConfig,
  };
}
